import { render, staticRenderFns } from "./platformGoodsDetail.vue?vue&type=template&id=72cfd3f4&scoped=true"
import script from "./platformGoodsDetail.vue?vue&type=script&lang=js"
export * from "./platformGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./platformGoodsDetail.vue?vue&type=style&index=0&id=72cfd3f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cfd3f4",
  null
  
)

export default component.exports